import { apiImplementationManager } from '@/plugins/axios';
import { useProjectStore } from '@/stores/project'

export const getClientInvite = (clientId) => {
  return apiImplementationManager.get(`clientinvites/${clientId}`, {
    skipAuth: true,
  });
};

export const getClient = (projectId) => {
  return apiImplementationManager.get(`onboardingprojects/${projectId}`);
};

export const GetClientSummaries = (clientIds) => {
  return apiImplementationManager.post(`clients/summaries/`, clientIds);
};

export const getIntermediary = (userId) => {
  return apiImplementationManager.get(`intermediaries/${userId}`);
};

export const getIntermediaries = () => {
  return apiImplementationManager.get(`intermediaries/all`);
};

export const getIntermediaryUsers = (intermediaryId) => {
  return apiImplementationManager.get(`intermediaries/${intermediaryId}/users`);
};

export const getProjectByClientId = (clientId) => {
  return apiImplementationManager.get(`clients/${clientId}/onboardingprojects/`);
};


export const getProject = (projectId) => {
  return apiImplementationManager.get(`onboardingprojects/${projectId}`);
};

export const refreshProject = async (projectId) => {
  const projectStore = useProjectStore()
  var project = await apiImplementationManager.get(`onboardingprojects/${projectId}`);
  
  projectStore.setProject(project.data)
};

export const getProjectTasks = (projectId) => {
  return apiImplementationManager.get(`onboardingprojects/${projectId}/projecttasks`);
};

export const getProjectCreationMeta = (projectId) => {
  return apiImplementationManager.get(`onboardingprojects/${projectId}/creationmeta/`);
};

export const getVerificationCheckTask = (taskId) => {
  return apiImplementationManager.get(`VerificationCheckContainers/${taskId}`);
};

export const putVerificationCheckTask = (taskId, data) => {
  return apiImplementationManager.put(`VerificationCheckContainers/${taskId}`, data);
};


export const postVerificationResolution = (data) => {
  return apiImplementationManager.post(`verificationCheckResolutions/`, data);
};


export const getContractSigningTask = (taskId) => {
  return apiImplementationManager.get(`slaTasks/${taskId}`);
};


export const getDirectDebitMandateTask = (taskId) => {
  return apiImplementationManager.get(`directdebitmandatetasks/${taskId}`);
};


export const getPreDiscoveryChecklist = (taskid) => {
  return apiImplementationManager.get(`prediscoverychecklisttasks/${taskid}`);
};

export const putPreDiscoveryChecklist = (projectId, data) => {
  return apiImplementationManager.put(`projecttasks/${projectId}/prediscoverychecklist?version=` + data.version, data);
};

export const getDataDiscoveryCollectionContainers = (id, data) => {
  return apiImplementationManager.get(`DiscoveryDataCollectionContainers/${id}`, data)
}


export const getDataCollectionTask = (taskId) => {
  return apiImplementationManager.get(`datacollectiontasks/${taskId}`);
};


export const getDataCollectionTasks = (projectId) => {
  return apiImplementationManager.get(`onboardingprojects/${projectId}/datacollectiontasks`);
};

export const putDataCollectionTask = (taskId, data) => {
  return apiImplementationManager.put(`datacollectiontasks/${taskId}`, data);
};

export const getPreSlaRequirementsAgreement = (taskId) => {
  return apiImplementationManager.get(`preslarequirementsagreements/${taskId}`);
};

export const getRequirementAgreementTask = (taskId) => {
  return apiImplementationManager.get(`RequirementAgreementTasks/${taskId}`);
};

export const putRequirementAgreementTask = (taskId, data) => {
  return apiImplementationManager.put(`RequirementAgreementTasks/${taskId}`, data);
};

export const putDirectDebitTask = (taskId, data) => {
  return apiImplementationManager.put(`directdebitmandatetasks/${taskId}`, data);
};



export const getFileCollectionContainer = (taskId) => {
  return apiImplementationManager.get(`FileCollectionContainers/${taskId}`);
};

export const getFileCollectionTask = (taskId) => {
  return apiImplementationManager.get(`FileCollectionTasks/${taskId}`);
};

export const getFileCollectionTasks = (projectId) => {
  return apiImplementationManager.get(`onboardingprojects/${projectId}/filecollectiontasks`);
};


export const postFileCollectionsAsComplete = (taskId) => {
  return apiImplementationManager.post(`FileCollectionContainers/${taskId}/?status=complete`);
};

export const putFileCollectionTask = (taskId, data) => {
  return apiImplementationManager.put(`filecollectiontasks/${taskId}`, data);
};

export const getFileMappingTask = (taskId) => {
  return apiImplementationManager.get(`filemappingtasks/${taskId}`);
};

export const getFileMappingTasks = (projectId) => {
  return apiImplementationManager.get(`onboardingprojects/${projectId}/filemappingtasks`);
};


export const putMilestone = (milestoneId, data) => {
  return apiImplementationManager.put(`milestones/${milestoneId}`, data);
};

export const getMilestone = (milestoneId) => {
  return apiImplementationManager.get(`milestones/${milestoneId}`);
};


